define('util/log',["require", "exports", "./http"], function (require, exports, http) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.error = exports.info = void 0;
    function info(message) {
        if (typeof location === "object") {
            post({
                level: "info",
                message: message,
                url: url()
            });
        }
    }
    exports.info = info;
    function error(message) {
        if (typeof location === "object") {
            post({
                level: "error",
                message: message,
                url: url()
            });
        }
        else {
            console.error(message);
        }
    }
    exports.error = error;
    /**
     * Get current page url
     */
    function url() {
        if (location.pathname === "/auth/complete") {
            return location.pathname;
        }
        else {
            return location.href; // include hash
        }
    }
    /**
     * Post log back to server
     */
    function post(message) {
        http.postJson("/log", message)
            .catch(function () { });
    }
    // Automatic page logging
    info("page view");
});
//# sourceMappingURL=/assets/javascripts/util/log.js.map;
